import styled from "styled-components"

const FieldRow = styled.div`
  display: flex;
  flex-direction: row;
  gap: var(--padding-primary);
`

export default FieldRow
